import getBrowserData from './getBrowserData';
import fetch from './fetch';

export default function logToSplunk(url, logData, headers) {
  const browserData = getBrowserData();
  const splunkLogData = { ...logData, ...browserData };
  return fetch('POST', url, splunkLogData, headers);
}
